import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMadeira = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1598)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 1.19072C15.6397 0.427875 13.8699 0 12 0C10.1301 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093C8.36025 23.5721 10.1301 24 12 24C13.8699 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.78263 1.19113C2.76867 3.13208 0 7.24251 0 12C0 16.7575 2.76867 20.8679 6.78263 22.8088V1.19113Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 1.19113V22.8088C21.2313 20.8679 24 16.7575 24 12C24 7.24251 21.2313 3.13208 17.2174 1.19113Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.3913 13.0435L16.1739 14.087V9.91303L15.3913 10.9565H13.0435V8.60869L14.087 7.82611H9.91303L10.9565 8.60869V10.9565H8.60869L7.82611 9.91303V14.087L8.60869 13.0435H10.9565V15.3913L9.91303 16.1739H14.087L13.0435 15.3913V13.0435H15.3913Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1305 11.4783H12.5217V8.86954H11.4783V11.4783H8.86955V12.5217H11.4783V15.1304H12.5217V12.5217H15.1305V11.4783Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1598",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMadeira;
